module.exports = __webpack_public_path__ + "img/login_pic.ce4a0523.jpg";